import { getShopifyData } from "../config";
import {GetCustomer} from "./GetCustomer";

export const Login = async (customer) => {
  const query = `mutation {
    customerAccessTokenCreate(input: {email: "${customer.email}", password: "${customer.password}"}) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }`;
  const response = await getShopifyData(query);
  const customerAccessToken = response.data.customerAccessTokenCreate?.customerAccessToken?.accessToken;
  let customerData = {};
  if (customerAccessToken) {
    customerData = await GetCustomer(customerAccessToken);
  }
  return {
    ...response.data.customerAccessTokenCreate,
    ...{customer: customerData.data?.customer}
  };
};
